import styled, { keyframes } from "styled-components";

export const VideoContainer = styled.div`
  position: relative;
  background: white;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  flex-grow: 1;
  height: 230px;

  video {
    width: 100%;
  }
`

export const RemoteContainer = styled.div`
  background: black;
  height: 230px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid ${(props) => props?.theme?.themeConfig?.primaryColor};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  padding: 20px 0;
  color: white;

  video {
    border-radius: 8px;
    width: 230px;
  }
`
export const RemoteMicOffContainer = styled.div`
  position: absolute;
  left: 10px;
  bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: red;
`

export const LocalContainer = styled.div<{ isCameraOn: boolean }>`
  background: black;
  width: 100px;
  height: 77px;
  border-radius: 8px;
  position: absolute;
  right: 10px;
  bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid white;

  video {
    width: inherit;
    border-radius: 8px;
  }
`

const haloAnimation = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(46, 204, 113, 0.5),
                0 0 0 0 rgba(46, 204, 113, 0.3),
                0 0 0 0 rgba(46, 204, 113, 0.1);
  }
  100% {
    box-shadow: 0 0 0 10px rgba(46, 204, 113, 0),
                0 0 0 20px rgba(46, 204, 113, 0),
                0 0 0 30px rgba(46, 204, 113, 0);
  }
`;

export const UserPlaceholder = styled.div<{ isTalking: boolean }>`
  width: 50px;
  height: 50px;
  background: #d9d9d9;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  color: black;

  border: ${props => props.isTalking ? `3px solid rgba(46, 204, 113, 0.5)` : '0'};
  animation: ${haloAnimation} 0.5s infinite ease-in-out 0.25s;
  ${props => props.isTalking ? '' : 'animation: none;'}
`